import {
  Dashboard as DashboardIcon,
  Extension as WidgetIcon,
  Search as SEOIcon,
  SmartToy as BotIcon,
  PhoneAndroid as MobileIcon,
  Speed as PerformanceIcon,
  CheckCircle as CheckIcon,
  Email as EmailIcon,
  Phone as PhoneIcon,
  ArrowForward as ArrowIcon,
  TrendingUp as TrendingIcon,
  Security as SecurityIcon,
  Star as StarIcon
} from '@mui/icons-material';
import {
  Box,
  Container,
  Typography,
  Grid,
  Card,
  CardContent,
  Button,
  Stack,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Paper,
  Chip,
  Divider
} from '@mui/material';

const PlatformFeatures = () => {
  const features = [
    {
      icon: <DashboardIcon />,
      title: 'Gelişmiş Yönetim Paneli',
      description: 'Haber, ilan, forum, blog gibi farklı içerikleri tek yerden yönetin. Rol bazlı yetkilendirme ile ekip çalışması.',
      items: [
        'İçerik ekleme ve düzenleme',
        'Rol bazlı yetkilendirme sistemi',
        'Zamanlama ve taslak yönetimi',
        'Çoklu dil desteği'
      ],
      color: '#1976d2',
      badge: 'Temel'
    },
    {
      icon: <WidgetIcon />,
      title: 'Sürükle-Bırak Widget Sistemi',
      description: 'React-Grid-Layout teknolojisi ile sayfalarınızı özgürce tasarlayın. Kısıtlayıcı şablonlara son.',
      items: [
        'Sürükle-bırak ile kolay tasarım',
        'Widget boyutlandırma ve konumlama',
        'Anında önizleme sistemi',
        'Kategoriye özel sayfa tasarımları'
      ],
      color: '#2e7d32',
      badge: 'Öne Çıkan'
    },
    {
      icon: <SEOIcon />,
      title: 'SEO & Google Optimizasyonu',
      description: 'İçerikleriniz arama motorlarında üst sıralarda yer alsın. Google News entegrasyonu ile daha fazla görünürlük.',
      items: [
        'SEO uyumlu URL ve meta etiketler',
        'Google News entegrasyonu',
        'Otomatik sitemap ve robots.txt',
        'Yapısal veri (Schema.org) desteği'
      ],
      color: '#ed6c02',
      badge: 'Kritik'
    },
    {
      icon: <BotIcon />,
      title: 'Otomatik Ajans Botları',
      description: 'Haber ajanslarından otomatik içerik çekin. AI destekli düzenleme ile zaman kazanın.',
      items: [
        'Otomatik haber ajansı entegrasyonu',
        'AI destekli başlık ve özet düzenleme',
        'Kategori atama ve filtreleme',
        'Yayın zamanlaması'
      ],
      color: '#9c27b0',
      badge: 'AI Powered'
    },
    {
      icon: <MobileIcon />,
      title: 'Mobil Uyumlu & Native App',
      description: 'Responsive tasarım ve iOS/Android native uygulamalar. Mobil kullanıcılar için optimize edilmiş deneyim.',
      items: [
        'Tam responsive tasarım',
        'iOS ve Android native uygulamalar',
        'Mobil özel story ve menü sistemi',
        'Push notification desteği'
      ],
      color: '#f44336',
      badge: 'Mobil'
    },
    {
      icon: <PerformanceIcon />,
      title: 'Next.js ile Yüksek Performans',
      description: 'SSR teknolojisi ile ultra hızlı yükleme. SEO ve sosyal medya için optimize edilmiş yapı.',
      items: [
        'SSR ile ultra hızlı yükleme (<300ms)',
        'SEO ve sosyal medya optimizasyonu',
        'CDN entegrasyonu',
        'Otomatik kod optimizasyonu'
      ],
      color: '#00bcd4',
      badge: 'Performans'
    }
  ];

  const stats = [
    { icon: <TrendingIcon />, value: '99.9%', label: 'Uptime Garantisi', color: '#10b981' },
    { icon: <SecurityIcon />, value: '<300ms', label: 'Yükleme Hızı', color: '#f59e0b' },
    { icon: <StarIcon />, value: '500+', label: 'Aktif Proje', color: '#6366f1' },
    { icon: <CheckIcon />, value: '24/7', label: 'Teknik Destek', color: '#ef4444' }
  ];

  return (
    <Box sx={{ 
      py: 10, 
      background: 'linear-gradient(180deg, #ffffff 0%, #f8fafc 50%, #f1f5f9 100%)',
      position: 'relative'
    }}>
      {/* Subtle background pattern */}
      <Box
        sx={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background: `
            radial-gradient(circle at 20% 30%, rgba(59, 130, 246, 0.05) 0%, transparent 50%),
            radial-gradient(circle at 80% 70%, rgba(16, 185, 129, 0.05) 0%, transparent 50%)
          `,
          pointerEvents: 'none'
        }}
      />

      <Container maxWidth="xl" sx={{ position: 'relative', zIndex: 1 }}>
        {/* Modern Header */}
        <Box sx={{ textAlign: 'center', mb: 10 }}>
          <Chip
            label="🚀 YENİ NESİL TEKNOLOJİ"
            sx={{
              background: 'linear-gradient(45deg, #3b82f6, #1d4ed8)',
              color: 'white',
              fontWeight: 600,
              mb: 3,
              px: 3,
              py: 1,
              fontSize: '0.9rem',
              boxShadow: '0 4px 20px rgba(59, 130, 246, 0.3)'
            }}
          />
          <Typography
            variant="h2"
            sx={{
              fontSize: { xs: '2.2rem', md: '3.5rem' },
              fontWeight: 800,
              mb: 3,
              color: '#1e293b',
              lineHeight: 1.2,
              position: 'relative',
              '&::after': {
                content: '""',
                position: 'absolute',
                bottom: -12,
                left: '50%',
                transform: 'translateX(-50%)',
                width: 80,
                height: 4,
                background: 'linear-gradient(45deg, #3b82f6, #10b981)',
                borderRadius: 2
              }
            }}
          >
            Dijital Yayıncılığın
            <Box component="span" sx={{ 
              background: 'linear-gradient(45deg, #3b82f6, #10b981)',
              backgroundClip: 'text',
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
              display: 'block'
            }}>
              Yeni Nesil Altyapısı
            </Box>
          </Typography>
          <Typography
            variant="h5"
            sx={{
              color: '#64748b',
              maxWidth: 700,
              mx: 'auto',
              lineHeight: 1.6,
              fontWeight: 400,
              fontSize: { xs: '1.1rem', md: '1.3rem' }
            }}
          >
            Her İçerik Türüne, Her Cihaza, Her Kullanıcıya Özel Güçlü Bir Altyapı
          </Typography>
        </Box>

        {/* Stats Section */}
        <Grid container spacing={3} sx={{ mb: 8 }}>
          {stats?.map((stat, index) => (
            <Grid item xs={6} md={3} key={index}>
              <Paper
                elevation={0}
                sx={{
                  p: 4,
                  textAlign: 'center',
                  background: 'rgba(255, 255, 255, 0.8)',
                  backdropFilter: 'blur(10px)',
                  border: '1px solid rgba(255, 255, 255, 0.2)',
                  borderRadius: 4,
                  transition: 'all 0.3s ease',
                  boxShadow: '0 4px 20px rgba(0, 0, 0, 0.08)',
                  '&:hover': {
                    borderColor: stat.color,
                    transform: 'translateY(-8px)',
                    boxShadow: `0 15px 40px ${stat.color}25`,
                    background: 'rgba(255, 255, 255, 0.95)'
                  }
                }}
              >
                <Box
                  sx={{
                    display: 'inline-flex',
                    p: 2.5,
                    borderRadius: 3,
                    background: `linear-gradient(45deg, ${stat.color}15, ${stat.color}08)`,
                    color: stat.color,
                    mb: 3,
                    boxShadow: `0 4px 15px ${stat.color}20`
                  }}
                >
                  {stat.icon}
                </Box>
                <Typography variant="h3" fontWeight={800} color={stat.color} gutterBottom>
                  {stat.value}
                </Typography>
                <Typography variant="body1" color="#64748b" fontWeight={600}>
                  {stat.label}
                </Typography>
              </Paper>
            </Grid>
          ))}
        </Grid>

        {/* Features Grid */}
        <Grid container spacing={4} sx={{ mb: 10 }}>
          {features?.map((feature, index) => (
            <Grid item xs={12} md={6} key={index}>
              <Card
                elevation={0}
                sx={{
                  p: 4,
                  height: '100%',
                  background: 'rgba(255, 255, 255, 0.9)',
                  backdropFilter: 'blur(10px)',
                  border: '1px solid rgba(255, 255, 255, 0.3)',
                  borderRadius: 4,
                  position: 'relative',
                  transition: 'all 0.4s ease',
                  boxShadow: '0 8px 25px rgba(0, 0, 0, 0.08)',
                  overflow: 'hidden',
                  '&::before': {
                    content: '""',
                    position: 'absolute',
                    top: 0,
                    left: '-100%',
                    width: '100%',
                    height: '100%',
                    background: `linear-gradient(90deg, transparent, ${feature.color}10, transparent)`,
                    transition: 'left 0.6s ease'
                  },
                  '&:hover': {
                    borderColor: `${feature.color}40`,
                    transform: 'translateY(-12px)',
                    boxShadow: `0 20px 50px ${feature.color}25`,
                    background: 'rgba(255, 255, 255, 0.95)',
                    '&::before': {
                      left: '100%'
                    }
                  }
                }}
              >
                {/* Badge */}
                <Chip
                  label={feature.badge}
                  size="small"
                  sx={{
                    position: 'absolute',
                    top: 20,
                    right: 20,
                    background: `linear-gradient(45deg, ${feature.color}20, ${feature.color}10)`,
                    color: feature.color,
                    fontWeight: 600,
                    fontSize: '0.75rem',
                    border: `1px solid ${feature.color}30`,
                    boxShadow: `0 2px 8px ${feature.color}20`,
                    zIndex: 2
                  }}
                />

                {/* Header */}
                <Box sx={{ display: 'flex', alignItems: 'flex-start', mb: 3, position: 'relative', zIndex: 1 }}>
                  <Box
                    sx={{
                      p: 2.5,
                      borderRadius: 3,
                      background: `linear-gradient(45deg, ${feature.color}15, ${feature.color}08)`,
                      color: feature.color,
                      mr: 3,
                      mt: 0.5,
                      boxShadow: `0 4px 15px ${feature.color}20`,
                      border: `1px solid ${feature.color}20`
                    }}
                  >
                    {feature.icon}
                  </Box>
                  <Box sx={{ flex: 1 }}>
                    <Typography variant="h5" fontWeight={700} gutterBottom color="#1e293b">
                      {feature.title}
                    </Typography>
                    <Typography
                      variant="body1"
                      color="#64748b"
                      sx={{ lineHeight: 1.6 }}
                    >
                      {feature.description}
                    </Typography>
                  </Box>
                </Box>

                <Divider sx={{ my: 3, borderColor: `${feature.color}20` }} />

                {/* Features List */}
                <List dense sx={{ p: 0, position: 'relative', zIndex: 1 }}>
                  {feature.items?.map((item, idx) => (
                    <ListItem key={idx} sx={{ px: 0, py: 1 }}>
                      <ListItemIcon sx={{ minWidth: 36 }}>
                        <Box
                          sx={{
                            width: 20,
                            height: 20,
                            borderRadius: '50%',
                            background: `linear-gradient(45deg, ${feature.color}, ${feature.color}dd)`,
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            boxShadow: `0 2px 8px ${feature.color}30`
                          }}
                        >
                          <CheckIcon sx={{ fontSize: 14, color: 'white' }} />
                        </Box>
                      </ListItemIcon>
                      <ListItemText
                        primary={item}
                        primaryTypographyProps={{
                          variant: 'body2',
                          fontWeight: 500,
                          color: '#475569'
                        }}
                      />
                    </ListItem>
                  ))}
                </List>
              </Card>
            </Grid>
          ))}
        </Grid>

        {/* Modern CTA */}
        <Paper
          elevation={0}
          sx={{
            p: 8,
            textAlign: 'center',
            background: `
              linear-gradient(135deg, #1e293b 0%, #334155 50%, #475569 100%),
              radial-gradient(circle at 30% 40%, rgba(59, 130, 246, 0.2) 0%, transparent 50%),
              radial-gradient(circle at 70% 60%, rgba(16, 185, 129, 0.2) 0%, transparent 50%)
            `,
            color: 'white',
            borderRadius: 6,
            position: 'relative',
            overflow: 'hidden',
            boxShadow: '0 20px 60px rgba(30, 41, 59, 0.3)',
            '&::before': {
              content: '""',
              position: 'absolute',
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              background: `
                repeating-linear-gradient(
                  90deg,
                  transparent,
                  transparent 98px,
                  rgba(255, 255, 255, 0.03) 100px
                )
              `,
              opacity: 0.5
            }
          }}
        >
          <Box sx={{ position: 'relative', zIndex: 1 }}>
            <Typography 
              variant="h3" 
              fontWeight={700} 
              gutterBottom
              sx={{
                fontSize: { xs: '2rem', md: '2.5rem' },
                background: 'linear-gradient(45deg, #ffffff, #a78bfa)',
                backgroundClip: 'text',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent'
              }}
            >
              Platformumuzu Keşfetmeye Hazır mısınız?
            </Typography>
            <Typography
              variant="h6"
              sx={{ 
                mb: 5, 
                color: 'rgba(255, 255, 255, 0.8)', 
                maxWidth: 600, 
                mx: 'auto',
                fontWeight: 400,
                lineHeight: 1.6
              }}
            >
              Size özel bir demo hazırlayalım ve tüm özelliklerimizi detaylıca gösterelim. 
              Dijital yayıncılığın geleceğini birlikte keşfedelim.
            </Typography>

            <Stack
              direction={{ xs: 'column', sm: 'row' }}
              spacing={3}
              justifyContent="center"
            >
              <Button
                variant="contained"
                size="large"
                endIcon={<ArrowIcon />}
                sx={{
                  background: 'linear-gradient(45deg, #3b82f6, #1d4ed8)',
                  color: 'white',
                  fontWeight: 700,
                  px: 6,
                  py: 2.5,
                  fontSize: '1.1rem',
                  borderRadius: '50px',
                  boxShadow: '0 8px 25px rgba(59, 130, 246, 0.4)',
                  '&:hover': {
                    background: 'linear-gradient(45deg, #2563eb, #1e40af)',
                    transform: 'translateY(-3px)',
                    boxShadow: '0 12px 35px rgba(59, 130, 246, 0.5)'
                  },
                  transition: 'all 0.3s ease'
                }}
              >
                Ücretsiz Demo Talep Et
              </Button>
              <Button
                variant="outlined"
                size="large"
                startIcon={<PhoneIcon />}
                sx={{
                  borderColor: 'rgba(255,255,255,0.5)',
                  color: 'white',
                  fontWeight: 600,
                  px: 6,
                  py: 2.5,
                  fontSize: '1.1rem',
                  borderRadius: '50px',
                  borderWidth: 2,
                  backdropFilter: 'blur(10px)',
                  '&:hover': {
                    borderColor: 'white',
                    bgcolor: 'rgba(255,255,255,0.1)',
                    transform: 'translateY(-3px)'
                  },
                  transition: 'all 0.3s ease'
                }}
              >
                Hemen İletişime Geç
              </Button>
            </Stack>
          </Box>
        </Paper>
      </Container>
    </Box>
  );
};

export default PlatformFeatures;